import React from 'react'
import { Helmet } from 'react-helmet-async'

type props = {
  title: string
  description: string
  address?: string
}
export const MetaTags: React.FC<props> = ({ title, description, address }) => {
  // don't render if we dont have all the necessary parts
  if (!title || !description) return null
  const getAddress = () => (address ? <link rel="canonical" href={address} /> : null)
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {getAddress()}
    </Helmet>
  )
}

export default MetaTags
